export default __webpack_public_path__ + "static/media/sip-logotype-d.54d308da.svg";